import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ErrorBoundary from './components/ErrorBoundary'

const HomePage = lazy(() => import('./pages/HomePage'))
const LivePage = lazy(() => import('./pages/LivePage'))
const WalletsPage = lazy(() => import('./pages/WalletsPage'))
const MarketsPage = lazy(() => import('./pages/MarketsPage'))
const PowerLawPage = lazy(() => import('./pages/PowerLawPage'))
const LearnPage = lazy(() => import('./pages/LearnPage'))
const CorporateHoldingsPage = lazy(() => import('./pages/CorporateHoldingsPage'))
const MicroStrategyPage = lazy(() => import('./pages/MicroStrategyPage'))

function App() {
  return (
    <>
      <div className="bg-matrix" />
      <div className="bg-gradient-overlay" />
      <ErrorBoundary>
        <Suspense fallback={<div className="p-6 text-center text-gray-400">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="live" element={<LivePage />} />
              <Route path="markets" element={<MarketsPage />} />
              <Route path="power-law" element={<PowerLawPage />} />
              <Route path="learn" element={<LearnPage />} />
              <Route path="treasuries" element={<CorporateHoldingsPage />} />
              <Route path="microstrategy" element={<MicroStrategyPage />} />
              <Route path="wallets" element={<WalletsPage />} />
            </Route>
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </>
  )
}

export default App
